import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getReleases } from '../../../actions/supportActions';

import ReleasesList from './ReleasesList';

class Releases extends Component {
  state = {
    releases: {
      Upcoming: {
        id: null,
        posts: [],
      },
      Available: {
        id: null,
        posts: [],
      },
    },
    activeTabIndex: 0,
    loading: true,
  }

  componentDidMount() {
    const { category } = this.props;
    const releases = _.cloneDeep(this.state.releases);
    _.map(category.children, item => {
      releases[item.name] = {
        id: item.id,
        posts: [],
      };
    });
    this.updateReleases(releases, category);
  }

  setSupportNav = () => {
    this.props.setSupportNav('Contact Us');
  }

  updateReleases = (releases, category) => {
    this.setState({ releases }, () => {
      const upcomingRelease = category.children.find(item => item.name === 'Upcoming');
      this.fetchRelease(upcomingRelease);
    });
  }

  sortByDate = (data, order) => {
    return _.orderBy(data, o => {
      return new Date(Number(o.meta.releaseDate) * 1000);
    }, [order]);
  }

  fetchRelease = category => {
    const releases = _.cloneDeep(this.state.releases);
    const sortOrder = category.name === 'Upcoming' ? 'asc' : 'desc';
    this.setState({ loading: true }, () => {
      getReleases(category.id)
        .then(response => {
          if (response) {
            releases[category.name].posts = this.sortByDate(response, sortOrder);
            this.setState({ releases, loading: false });
          } else {
            this.setState({ loading: false });
          }
        });
    });
  }

  handleTabChange = (index, categoryId) => {
    const { category } = this.props;
    this.setState({ activeTabIndex: index }, () => {
      const activeCategory = category.children.find(item => item.id === categoryId);
      if (_.isEmpty(this.state.releases[activeCategory.name].posts)) {
        this.fetchRelease(activeCategory);
      }
    });
  }


  renderTabs = () => {
    const { releases, activeTabIndex, loading } = this.state;
    let tabData = '';
    const tabItems = Object.keys(releases).map((item, index) => {
      if (activeTabIndex === index) {
        const posts = releases[item].posts;
        if (posts.length > 0) {
          tabData = (
            <ReleasesList
              releases={posts}
              setSupportNav={this.setSupportNav}
            />
          );
        } else {
          tabData = loading ? <div>loading....</div> : (
            <div>No {item} releases available.</div>
          );
        }
      }
      return (
        <li key={index} className={`custom-tab--nav-item ${activeTabIndex === index ? 'custom-tab--nav-active' : ' '}`}>
          <button onClick={() => this.handleTabChange(index, releases[item].id)} className="custom-tab--nav-link">
            {item} Releases
          </button>
        </li>
      );
    });

    return (
      <div className="custom-tab">
        <div className="custom-tab--navigation">
          <ul className="custom-tab--nav">
            {tabItems}
          </ul>
        </div>
        <div className="custom-tab--body custom-tab-block">
          <div className="support-user-guide-table">
            {tabData}
          </div>
        </div>
      </div>
    );
  }


  render() {
    return (
      <div className="resources-main-container release-schedules">
        {this.renderTabs()}
      </div>
    );
  }
}

Releases.propTypes = {
  category: PropTypes.instanceOf(Object),
  setSupportNav: PropTypes.func,
};

export default Releases;
